import { CSSProgressiveBody03Medium } from "@caisy/league";
import styled from "styled-components";

export const SMainMenuUserPopupListItemWrapper = styled.div`
  > div {
    padding: 12px 16px 11px;
    ${CSSProgressiveBody03Medium};
  }
`;
